import React from 'react'

import Base from '../_Base'

const Checkmark = (props) => (
  <Base width="16" height="16" viewBox="2 2 16 16" {...props} fill="none">
    <path
      d="M6,10 C7.93333333,12 8.93333333,13 9,13 C9.06666667,13 10.7333333,11 14,7"
      strokeWidth="2"
      stroke="currentColor"
    />
  </Base>
)

export default Checkmark
